import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, GoogleAuthProvider, signInWithPopup} from 'firebase/auth';
import './SignupPage.css'

export default function SignupPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/dashboard'); 
    } catch (err) {
      alert(err.message);
    }
  };
  const handleGoogleLogin = async () => {
      setError(null);
      try {
        const provider = new GoogleAuthProvider();
        await signInWithPopup(auth, provider);
        navigate('/dashboard');
      } catch (err) {
        console.error("Google Login Error:", err);
        if (err.code === 'auth/popup-closed-by-user') {
          setError('Google sign-in was cancelled.');
        } else if (err.code === 'auth/cancelled-popup-request') {
          setError('Another pop-up request is pending. Please try again.');
        } else if (err.code === 'auth/account-exists-with-different-credential') {
          setError('An account with this email already exists using a different sign-in method.');
        } else {
          setError('Google sign-in failed. Please try again.');
        }
      }
    };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h1 className="signup-title">🚀 Rocket Prep</h1>
        <h2 className="signup-subtitle">Sign Up</h2>

        <form onSubmit={handleSignup} className="signup-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="signup-input"
          /><br/>
          <input
            type="password"
            placeholder="Password (6+ characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="signup-input"
          /><br/>
          <button type="submit" className="signup-button">Sign Up</button>
        </form>
        <p className="or-text">OR</p>

        <button onClick={handleGoogleLogin} className="google-button">Sign In with Google</button>
      </div>
    </div>
  );
}
